/** The result count printed above Admin Task > School List.

Three searches feed that table and they know DIFFERENT things about their own
size, so one `rows.length` would be a lie in two of them:

  * SUBSCRIPTION KEYWORD mode (the eLAFP button) merges a fan-out on the client
    and holds the whole union, then slices it to the chosen result limit. The
    total is real and usually LARGER than what the table shows;
  * ONE PICKED SUBSCRIPTION returns every matching row —
    get_schools_by_subscription applies no LIMIT at all — so the rows on screen
    are the total;
  * THE PLAIN LIST is windowed by the server (`limit`), so a full page means
    "at least this many", never "this many". Claiming a total there would be
    wrong exactly when it matters — a school missing from a capped list reads
    as a school that does not exist.

`capped` marks that third case. It is inferred from a page that came back
exactly full, which is the only signal the command gives: get_filtered_school_list
returns rows, not a count, so a set that happens to be exactly `limit` long is
reported as possibly-incomplete. Over-warning is the safe direction.
*/

export function describeSchoolResultCount({
  keywordActive = false,
  subscriptionPicked = false,
  rows = [],
  keywordAllRows = [],
  limit = 0,
} = {}) {
  const shown = Array.isArray(rows) ? rows.length : 0;
  const max = parseInt(limit, 10) || 0;

  if (keywordActive) {
    const all = Array.isArray(keywordAllRows) ? keywordAllRows.length : 0;
    // The union is the truth even when the slice on screen is shorter.
    const total = Math.max(all, shown);
    return { shown, total, truncated: total > shown, capped: false };
  }

  if (subscriptionPicked) {
    return { shown, total: shown, truncated: false, capped: false };
  }

  return {
    shown,
    total: shown,
    truncated: false,
    capped: max > 0 && shown >= max,
  };
}
